// Environment configuration file
// Centralizes all environment variable access without fallback values

export const ENV_CONFIG = {
  // API Configuration
  API: {
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
    TIMEOUT: parseInt(process.env.REACT_APP_TIMEOUT) || 90000
  },

  // Microsoft Azure AD Configuration
  AZURE: {
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
    TENANT_ID: process.env.REACT_APP_TENANT_ID,
    AUTHORITY: process.env.REACT_APP_AUTHORITY,
    REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI
  },

  // External Resources
  EXTERNAL: {
    GOOGLE_FONTS_URL: process.env.REACT_APP_GOOGLE_FONTS_URL,
    ICONIFY_SCRIPT_URL: process.env.REACT_APP_ICONIFY_SCRIPT_URL
  },

  // Build Information
  BUILD: {
    TIMESTAMP: process.env.REACT_APP_BUILD_TIMESTAMP,
    DATE: process.env.REACT_APP_BUILD_DATE
  }
};

// Helper function to validate required environment variables
export const validateEnvironment = () => {
  const requiredVars = [
    'REACT_APP_BACKEND_URL',
    'REACT_APP_CLIENT_ID',
    'REACT_APP_TENANT_ID',
    'REACT_APP_AUTHORITY',
    'REACT_APP_REDIRECT_URI',
    'REACT_APP_GOOGLE_FONTS_URL',
    'REACT_APP_ICONIFY_SCRIPT_URL'
  ];

  const missingVars = requiredVars.filter(varName => !process.env[varName]);
  
  if (missingVars.length > 0) {
    console.error('Missing required environment variables:', missingVars);
    console.error('Please set these variables in your .env file.');
    throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
  }

  return true;
};

// Development helper to log current configuration
export const logConfiguration = () => {
  if (process.env.NODE_ENV === 'development') {
    console.log('Current Environment Configuration:', {
      API: ENV_CONFIG.API,
      AZURE: ENV_CONFIG.AZURE,
      EXTERNAL: ENV_CONFIG.EXTERNAL,
      BUILD: ENV_CONFIG.BUILD
    });
  }
};
